import React from 'react';
import { Case, CaseStatus, Invoice, getInvoice } from '../../../services/buildfire/rdb/cases';
import InfoSection, { LineItem } from './InfoSection';
import { IonRouterLink } from '@ionic/react';
import { getDatabase } from 'firebase/database';
import { useFirebase } from '../../../services/firebase';
import { formatCurrencyCents } from '../../../util/currency';

interface AdminPaymentInfoProps {
  case: Case;
}

const getPaymentStatusDescription = (c: Case) => {
  if (c.invoiceAccount) {
    // invoiced case
    if (c.uid !== c.invoiceAccount.uid) {
      return (
        <span>
          Invoiced to{' '}
          <IonRouterLink
            routerLink={`/admin/users/${c.invoiceAccount.uid}`}
            style={{ textDecoration: 'underline' }}
          >
            {c.invoiceAccount.displayName}
          </IonRouterLink>
        </span>
      );
    }
    return `Invoiced`;
  }

  // otherwise immediate payment
  if (c.status === CaseStatus.SIGNED_OFF) {
    return 'Paid';
  }
  return 'Pending';
};

const AdminPaymentInfo: React.FC<AdminPaymentInfoProps> = ({ case: c }) => {
  const { app } = useFirebase();
  const [invoice, setInvoice] = React.useState<Invoice | null>(null);

  React.useEffect(() => {
    const db = getDatabase(app);
    getInvoice(db, c.id)
      .then(setInvoice)
      .catch((error) => {
        console.error('Error loading invoice:', error);
        setInvoice(null);
      });
  }, [c.id, c.sites.length, app]);

  const totalCents =
    invoice?.products?.map((p) => p.amount)?.reduce((a, b) => a + b, 0) || 0;
  const total = totalCents > 0 ? formatCurrencyCents(totalCents) : 'N/A';

  return (
    <InfoSection title="Payment Info">
      <LineItem name="Total Charge" description={total} />
      <LineItem
        name="Payment status"
        description={getPaymentStatusDescription(c)}
      />
    </InfoSection>
  );
};

export default AdminPaymentInfo;
